import React from 'react';
import { Avatar, Button } from 'antd';
import { UserOutlined, FileOutlined, DownloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getImg } from '../../../Api/getImg';

const getPdfUrl = (docId) => {
    if (!docId) return null;
    const baseURL = process.env.REACT_APP_BASE_URL;
    return `${baseURL}/api/Storage/GetPDFById?Id=${docId}`;
};

const InitialMessage = ({ ovr, getStaffInfo }) => {
    return (
        <div className="mb-6">
            <div className="flex items-start gap-3">
                <Avatar 
                    size={40} 
                    icon={<UserOutlined />} 
                    className="bg-[#298d9f] flex-shrink-0"
                />
                <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                        <span className="font-semibold text-sm">
                            {getStaffInfo(ovr.adminUserId)?.name || 'Unknown'}
                        </span>
                        <span className="text-xs text-gray-500">
                            {dayjs(ovr.createdAt).format('MMM D, YYYY [at] h:mm A')}
                        </span>
                        {ovr.updatedAt&&
                        <span className="text-xs text-gray-500">
                          <b>updated on </b>  {dayjs(ovr.updatedAt).format('MMM D, YYYY [at] h:mm A')}
                        </span>}
                    </div>
                    <div className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm">
                        <p className="text-sm text-gray-800 font-medium mb-2">
                            📋 {ovr.title}
                        </p>
                        <p className="text-sm text-gray-700 mb-2">
                            {ovr.body}
                        </p>
                        
                        {/* Image Attachment */}
                        {ovr.photoId && (
                            <div className="mt-3">
                                <img
                                    src={getImg(ovr.photoId)}
                                    alt="OVR Attachment"
                                    className="rounded max-w-full max-h-36 cursor-pointer hover:opacity-90 transition border border-gray-200"
                                    onClick={() => window.open(getImg(ovr.photoId), '_blank')}
                                />
                            </div>
                        )}
                        
                        {/* PDF Attachment */}
                        {ovr.docId && (
                            <div className="mt-3 flex items-center gap-2 p-2 bg-blue-50 border border-blue-200 rounded">
                                <FileOutlined className="text-blue-600" />
                                <span className="text-xs text-gray-700 flex-1">
                                    Document.pdf
                                </span>
                                <Button
                                    type="link"
                                    size="small"
                                    icon={<DownloadOutlined />}
                                    href={getPdfUrl(ovr.docId)}
                                    target="_blank"
                                >
                                    Download
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InitialMessage;